import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles, Typography, Grid } from "@material-ui/core";

import { BY_MY } from "../../../../constants";
import { Toggle } from "../../../../components/toggle";
import { GRAPH_UNITS } from "../../../dashboard/constants";
import { requestDateFormat, api } from "../../../../services";
import { StackedAreaChart } from "../../../../components/charts";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { NoDataCard } from "../../../../components/parts";
import { POWER_ASSETS_COLORS, POWER_ASSETS_LEGENDS } from "../../constants";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
  areaChart: {
    marginTop: `${theme.spacing(5.25)}px`,
    height: "240px",
  },
}));

const areas = [
  {
    key: "trading",
    stroke: POWER_ASSETS_COLORS[POWER_ASSETS_LEGENDS.TRADING],
    fill: POWER_ASSETS_COLORS[POWER_ASSETS_LEGENDS.TRADING],
  },
  {
    key: "battery",
    stroke: POWER_ASSETS_COLORS[POWER_ASSETS_LEGENDS.BATTERY],
    fill: POWER_ASSETS_COLORS[POWER_ASSETS_LEGENDS.BATTERY],
  },
  {
    key: "ev",
    stroke: POWER_ASSETS_COLORS[POWER_ASSETS_LEGENDS.EV],
    fill: POWER_ASSETS_COLORS[POWER_ASSETS_LEGENDS.EV],
  },
];

export const RevenuesOverTime = ({ period, startDate, endDate, graphUnit }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [byFilter, setByFilter] = useState();
  const [defaultFilter, setDefaultFilter] = useState();
  const [currentUrl, setCurrentUrl] = useState();
  const [rawData, setRawData] = useState([]);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  useEffect(() => {
    if (rawData) {
      const data = rawData.map((item) => {
        const date = new Date(item.date);
        return {
          ...item,
          trading: graphUnit === GRAPH_UNITS.kwh ? item.trading_kwh : item.trading,
          battery: graphUnit === GRAPH_UNITS.kwh ? item.battery_kwh : item.battery,
          ev: graphUnit === GRAPH_UNITS.kwh ? item.ev_kwh : item.ev,
          unit: graphUnit === GRAPH_UNITS.kwh ? "kWh" : currencySymbol,
          x: `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}`,
        };
      });
      setData(data);
    }
  }, [rawData, graphUnit]);

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => {
        setRawData(resp.data.results);
        setDefaultFilter(resp.data.date_format === "year" ? BY_MY[1] : BY_MY[0]);
      });
    };

    setByFilter(null);
    let url = "/praas/v1/power-revenue/overview/over-time/";
    if (period.name === "RANGE" && endDate) {
      url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
      getData(url);
      setCurrentUrl(url);
    } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
      url += `?date_filter=${period.filter}`;
      getData(url);
      setCurrentUrl(url);
    }
  }, [period, startDate, endDate]);

  useEffect(() => {
    if (byFilter) {
      let dateFormat = `date_format=${byFilter === BY_MY[0] ? "month" : "year"}`;

      api.get(`${currentUrl}&${dateFormat}`).then((resp) => {
        const data = resp.data.results.map((item) => {
          const date = new Date(item.date);
          return {
            ...item,
            x: `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}`,
          };
        });
        setData(data);
      });
    }
  }, [currentUrl, byFilter]);

  return (
    <ShaDowBox style={{ width: "100%" }}>
      {data.length ? (
        <div className={classes.box} id="production-overtime">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h4" style={{ marginRight: 3 }}>
                Revenues Over Time
              </Typography>
            </Grid>
            <Grid
              item
              container
              justifyContent="flex-end"
              alignItems="center"
              style={{ flex: 1, flexWrap: "nowrap" }}
            >
              <Grid container item style={{ width: "fit-content", flexWrap: "nowrap" }}>
                <Typography style={{ marginRight: 4 }}>By:</Typography>
                <Toggle
                  value={byFilter || defaultFilter}
                  options={BY_MY}
                  onChanged={setByFilter}
                  styles={{ width: 14 }}
                />
              </Grid>
            </Grid>
          </Grid>
          <div className={classes.areaChart}>
            <StackedAreaChart
              data={data}
              areas={areas}
              unit={graphUnit === GRAPH_UNITS.kwh ? "kwh" : currencySymbol}
              onlyLeftRightXAxis
              hideXAxis={true}
              hideYAxis={true}
              hideSumOnToolTip
            />
          </div>
        </div>
      ) : (
        <NoDataCard title="Revenues Over Time" />
      )}
    </ShaDowBox>
  );
};
